// Package Imports
// import PrivateRouteConst from 'core/common/privateRouteConstant';
import routeName from 'core/common/routeName';
import PrivateRoute from 'core/utils/PrivateRoute';
import { Route } from 'react-router-dom';
import React, { Suspense, lazy } from 'react';
import Loading from 'components/loading/loading';
import PrivateRouteConst from 'core/common/privateRouteConstant';

// Project Imports
// const DashboardChartMapping = lazy(
//   () => import('pages/dashboardMapping/dashboardChartMapping')
// );
const NeedToPay = lazy(() => import('pages/needToPay/needToPay'));
const NeedToPayRoute = (
  <Route path={routeName.needToPay}>
    <Route
      index
      element={
        <PrivateRoute name={PrivateRouteConst.NEED_TO_PAY_VIEW}>
          <Suspense
            fallback={
              <div>
                <Loading />
              </div>
            }
          >
            <NeedToPay />
          </Suspense>
        </PrivateRoute>
      }
    />
  </Route>
);

export default NeedToPayRoute;
